// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5a7b505c","977":"ee50f06d"}[chunkId] + ".chunk.js";
};